import { client } from './client';

export const STEP_UP_REQUIRED_ERROR_CODE = 'step_up_auth_required';

export enum StepUpChallenge {
  MfaSms = 'CHALLENGE_MFA_SMS',
  MfaTotp = 'CHALLENGE_MFA_TOTP',
  Password = 'CHALLENGE_PASSWORD',
}

export type StepUpBeginResponse = {
  challengeName: StepUpChallenge;
};

export type StepUpFinishRequest = {
  code?: string;
  password?: string;
};

export const isStepUpRequiredError = (error: unknown): boolean =>
  typeof error === 'object' && error !== null && (error as { code?: unknown }).code === STEP_UP_REQUIRED_ERROR_CODE;

export class StepUpRepository {
  static async begin() {
    return client.post<object, StepUpBeginResponse>('/dashboard/step-up/begin', {}, { sandbox: true });
  }

  static async finish(request: StepUpFinishRequest) {
    return client.post<StepUpFinishRequest, object>('/dashboard/step-up/finish', request, { sandbox: true });
  }
}
